import { Component, Input } from '@angular/core';
import { NgForOf } from '@angular/common';
import { RouterLink } from '@angular/router';

import { OrderInfoItem } from './order-info-card.interface';

@Component({
  selector: 'app-order-info-card',
  standalone: true,
  imports: [NgForOf, RouterLink],
  templateUrl: './order-info-card.component.html',
  styleUrl: './order-info-card.component.scss',
})
export class OrderInfoCardComponent {
  @Input({ required: true }) title: string;
  @Input({ required: true }) items: OrderInfoItem[];
}
